import {
  ConeGeometry,
  CylinderGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  SphereGeometry,
  TorusGeometry
} from 'three';

/** Lux mesh — staff + light orb cue (OCP registry). */
export function createLuxMesh(team = 'blue') {
  const group = new Group();
  const trim = team === 'blue' ? 0x38bdf8 : 0xfbbf24;
  const robeMat = new MeshStandardMaterial({ color: 0x1e3a8a, roughness: 0.55 });
  const trimMat = new MeshStandardMaterial({ color: trim, roughness: 0.4 });
  const staffMat = new MeshStandardMaterial({ color: 0xcbd5e1, metalness: 0.7, roughness: 0.3 });

  const body = new Mesh(new ConeGeometry(0.65, 2.3, 10), robeMat);
  body.position.y = 1.35;
  group.add(body);

  const head = new Mesh(new SphereGeometry(0.4, 12, 12), trimMat);
  head.position.y = 2.7;
  group.add(head);

  const staff = new Mesh(new CylinderGeometry(0.05, 0.06, 2.4, 8), staffMat);
  staff.position.set(0.75, 1.8, 0.2);
  group.add(staff);

  const orb = new Mesh(new SphereGeometry(0.22, 10, 10), trimMat);
  orb.position.set(0.75, 3.1, 0.2);
  group.add(orb);

  const halo = new Mesh(new TorusGeometry(0.35, 0.04, 8, 16), trimMat);
  halo.rotation.x = Math.PI / 2;
  halo.position.y = 3.15;
  group.add(halo);

  return group;
}
